__webpack_require__.p = "/react-admin-dashboard/";